export default "__VITE_ASSET__CR$sacFY__"